import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import CustomFileUploader from '../../components/common/CustomFileUploader';
import { resolveMedia } from '../../utils/media';
import { CardSkeleton, SkeletonText } from '../../components/common/Skeleton';

const fieldStyle = { width:'100%', padding:12, border:'1px solid #d0d5dd', borderRadius:10 };
const toUploader = (list=[]) => (Array.isArray(list) ? list : [list]).filter(Boolean).map((url) => ({ id:url, url, source:'server' }));

export default function AddBlog() {
  const [params] = useSearchParams();
  const id = params.get('id');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(!!id);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title:'', excerpt:'', content:'', category:'General', tags:'', status:'draft', featured:false });
  const [coverItems, setCoverItems] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);

  useEffect(() => {
    if (!id) return;
    httpAction({ url: `${apis().blogDetail}/${id}?admin=1`, silent: true }).then((result) => {
      if (result?.status) {
        const blog = result.blog || {};
        setForm({
          title: blog.title || '', excerpt: blog.excerpt || '', content: blog.content || '', category: blog.category || 'General',
          tags: (blog.tags || []).join(', '), status: blog.status || 'draft', featured: !!blog.featured,
        });
        setCoverItems(toUploader(blog.coverImage));
        setGalleryItems(toUploader(blog.gallery || []));
      }
      setLoading(false);
    });
  }, [id]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSaving(true);
    const payload = {
      ...form,
      tags: form.tags,
      coverImage: coverItems?.[0]?.url || '',
      gallery: galleryItems.map((item) => item.url).filter(Boolean),
    };
    const result = await httpAction({ url: id ? `${apis().blogAdd.replace('/add','')}/update/${id}` : apis().blogAdd, method: id ? 'PUT' : 'POST', body: payload });
    setSaving(false);
    if (result?.status) navigate('/admin/blogs');
  };

  if (loading) return <div><SkeletonText width="160px" height={28} /><div style={{ marginTop:18 }}><CardSkeleton count={2} height={260} /></div></div>;

  return (
    <form onSubmit={submitHandler} style={{ display:'grid', gap:16 }}>
      <div><h2 style={{ margin:0 }}>{id ? 'Edit Blog' : 'Add Blog'}</h2><p style={{ color:'#667085' }}>Create dynamic blog content with real image uploads for cover and gallery.</p></div>
      <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:18, alignItems:'start' }}>
        <div style={{ display:'grid', gap:16 }}>
          <input value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})} placeholder="Title" required style={fieldStyle} />
          <textarea rows="3" value={form.excerpt} onChange={(e)=>setForm({...form,excerpt:e.target.value})} placeholder="Excerpt" style={fieldStyle} />
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16 }}>
            <input value={form.category} onChange={(e)=>setForm({...form,category:e.target.value})} placeholder="Category" style={fieldStyle} />
            <input value={form.tags} onChange={(e)=>setForm({...form,tags:e.target.value})} placeholder="Tags separated by comma" style={fieldStyle} />
            <select value={form.status} onChange={(e)=>setForm({...form,status:e.target.value})} style={fieldStyle}><option value="draft">Draft</option><option value="published">Published</option></select>
          </div>
          <label style={{ display:'flex', alignItems:'center', gap:10 }}><input type="checkbox" checked={form.featured} onChange={(e)=>setForm({...form,featured:e.target.checked})} /> Featured post</label>
          <textarea rows="12" value={form.content} onChange={(e)=>setForm({...form,content:e.target.value})} placeholder="HTML content" style={fieldStyle} />
        </div>
        <div style={{ display:'grid', gap:16 }}>
          <div style={{ background:'#fff', borderRadius:18, padding:16 }}>
            <h4>Cover Image</h4>
            <CustomFileUploader multiple={false} onEdit={coverItems} onChange={setCoverItems} />
            <img src={resolveMedia(coverItems?.[0]?.url)} alt="cover preview" style={{ width:'100%', height:180, objectFit:'cover', borderRadius:14, marginTop:12 }} />
          </div>
          <div style={{ background:'#fff', borderRadius:18, padding:16 }}>
            <h4>Gallery Images</h4>
            <CustomFileUploader multiple={true} onEdit={galleryItems} onChange={setGalleryItems} />
          </div>
        </div>
      </div>
      <div style={{ display:'flex', gap:12 }}><button type="submit" disabled={saving} style={{ padding:'14px 20px', border:'none', borderRadius:12, background:'#0f5ef7', color:'#fff', fontWeight:700 }}>{saving ? 'Saving...' : 'Save Blog'}</button><button type="button" onClick={() => navigate('/admin/blogs')} style={{ padding:'14px 20px', borderRadius:12 }}>Cancel</button></div>
    </form>
  );
}
